<template>
    <div class="dashboard">
        <section class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="block">
                    <h2>{{ $t('dashboard.startWithMovement') }}</h2>
                    <router-link id="simtool_create_movement_profile" to="/scenarios" class="button--primary">
                        {{ $t('dashboard.createMovementProfile') }}
                    </router-link>
                </div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div class="block">
                    <h2>{{ $t('dashboard.searchProduct') }}</h2>
                    <div class="row">
                        <div class="col-md-12  col-lg-8">
                            <input
                                v-on:keyup.13="search"
                                type="text"
                                class="input_text"
                                v-model="motorSearch"
                                :placeholder="$t('dashboard.motorSearchInputPlaceholder')"
                            />
                        </div>
                        <div class="col-md-12  col-lg-4">
                            <router-link
                                id="simtool_search"
                                class="button--primary"
                                ref="searchButton"
                                :to="getSearchLink()"
                            >
                                {{ $t('common.search') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <divider cssClass="divider--text">{{ $t('common.or') }}</divider>

        <motor-type-selector v-on:select="selectMotor"></motor-type-selector>

        <modal type="small" v-if="showQuoteDialog" v-on:close="closeDialogs" v-on:submit="quote">
            <h2>{{ $t('common.modals.chooseScenario') }}</h2>

            <p>{{ $t('common.modals.quoteMessage') }}</p>

            <p>{{ $t('common.modals.scenarioForQuote') }}</p>

            <form class="form">
                <div class="select">
                    <select v-model="selectedScenario">
                        <option
                            v-for="scenario in scenarios"
                            :key="scenario.id"
                            v-bind:value="scenario.id"
                        >
                            {{ scenario.name }}
                        </option>
                    </select>
                </div>

                <textarea
                    class="form__input--textarea textarea"
                    v-model="quoteMessage"
                    :placeholder="$t('common.modals.quoteInputPlaceholder')"
                ></textarea>
            </form>

            <button class="button--primary no-margin" @click="quote">
                <span v-if="requestingQuote" class="spinner--alt"></span>
                {{ $t('common.modals.getQuote') }}
            </button>
            <button class="button--link no-margin margin-right" @click="closeDialogs">
                {{ $t('common.cancel') }}
            </button>
        </modal>

        <modal type="small" v-if="showHelpDialog" v-on:close="closeDialogs" v-on:submit="help">
            <h2>
                <span>{{ $t('common.modals.chooseScenario') }}</span>
                <icon-link
                    :href="$t('navigation.manual_url')"
                    target="_blank"
                    iconName="mdi-book-open-variant"
                    class="pull-right"
                >
                    {{ $t('common.manual') }}
                </icon-link>
            </h2>

            <p>{{ $t('common.modals.helpScenario') }}</p>

            <form class="form">
                <div class="select">
                    <select v-model="selectedScenario">
                        <option
                            v-for="scenario in scenarios"
                            :key="scenario.id"
                            v-bind:value="scenario.id"
                        >
                            {{ scenario.name }}
                        </option>
                    </select>
                </div>

                <input
                    type="text"
                    autofocus
                    class="input_text"
                    v-model="helpContact"
                    :placeholder="$t('common.modals.helpContactPlaceholder')"
                />

                <textarea
                    class="form__input--textarea textarea"
                    v-model="helpMessage"
                    :placeholder="$t('common.modals.helpMessagePlaceholder')"
                ></textarea>
            </form>

            <button class="button--primary no-margin" @click="help">
                <span v-if="requestingHelp" class="spinner--alt"></span>
                {{ $t('common.getHelp') }}
            </button>
            <button class="button--link no-margin margin-right" @click="closeDialogs">
                {{ $t('common.cancel') }}
            </button>
        </modal>

        <modal type="small" v-if="share" v-on:close="closeDialogs" v-on:submit="shareScenario">
            <h2>{{ $t('common.share') }}</h2>

            <p>{{ $t('common.modals.sharingMessage') }}</p>

            <p>{{ $t('common.modals.selectScenarioToShare') }}</p>

            <form class="form">
                <div class="select">
                    <select v-model="selectedScenario">
                        <option
                            v-for="scenario in scenarios"
                            :key="scenario.id"
                            v-bind:value="scenario.id"
                        >
                            {{ scenario.name }}
                        </option>
                    </select>
                </div>

                <input
                    type="text"
                    autofocus
                    class="input_text"
                    v-model="shareEmail"
                    :placeholder="$t('common.modals.shareEmailPlaceholder')"
                />

                <textarea
                    type="text"
                    class="form__input--textarea textarea"
                    v-model="shareMessage"
                    :placeholder="$t('common.modals.shareMessagePlaceholder')"
                ></textarea>
            </form>

            <button
                :disabled="shareEmail === undefined || shareEmail.length <= 0"
                class="button--primary no-margin"
                @click="shareScenario"
            >
                <span v-if="requestingShare" class="spinner--alt"></span>
                {{ $t('common.share') }}
            </button>
            <button class="button--link no-margin margin-right" @click="closeDialogs">
                {{ $t('common.cancel') }}
            </button>
        </modal>

        <top_success v-if="successMessage !== undefined && successMessage.length > 0">
            <p>{{ successMessage }}</p>
        </top_success>

        <top_warning v-if="warning !== undefined && warning.length > 0">
            <p>{{ warning }}</p>
        </top_warning>

        <top_error v-if="errorMessage !== undefined && errorMessage.length > 0">
            <p>{{ errorMessage }}</p>
        </top_error>
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Divider from '../components/Divider';
import MotorTypeSelector from '../components/MotorTypeSelector';
import Modal from '../components/Modal';
import { mapState } from 'vuex';
import Scenario from '../models/Scenario';

@Component({
    computed: mapState({
        scenarios: state => state.scenarios.scenarios,
    }),
})
export default class Hello extends Vue {
    name = 'dashboard';

    showQuoteDialog = false;
    showHelpDialog = false;
    selectedScenario = -1;

    successMessage = '';
    helpMessage = '';
    errorMessage = '';
    warning = '';
    quoteMessage = '';
    helpContact = '';

    requestingQuote = false;
    requestingHelp = false;

    share = false;
    requestingShare = false;
    shareMessage = '';

    motorSearch = '';

    /* eslint-disable no-useless-escape */
    emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    mounted() {
        this.$eventHub.$on('request-quote', this.quoteDialog);
        this.$eventHub.$on('request-help', this.helpDialog);
        this.$eventHub.$on('request-pdf', () => {
            this.$eventHub.$emit('request-pdf-complete');
        });
        this.$eventHub.$on('request-share', this.getShareDialog);

        this.$eventHub.$emit('motor-changed', {
            isTorque: false,
        });
    }

    beforeDestroy() {
        this.$eventHub.$off('request-quote', this.quoteDialog);
        this.$eventHub.$off('request-help', this.helpDialog);
        this.$eventHub.$off('request-share', this.getShareDialog);
        this.$eventHub.$off('request-pdf');
    }

    quoteDialog() {
        this.showQuoteDialog = true;
    }

    helpDialog() {
        this.showHelpDialog = true;
    }

    closeDialogs() {
        this.showQuoteDialog = false;
        this.showHelpDialog = false;
        this.selectedScenario = -1;

        this.requestingQuote = false;
        this.requestingHelp = false;

        this.share = false;
        this.shareEmail = undefined;
        this.requestingShare = false;
        this.shareMessage = '';

        this.$eventHub.$emit('request-quote-complete');
        this.$eventHub.$emit('request-help-complete');
    }

    quote() {
        if (this.selectedScenario !== -1) {
            this.requestingQuote = true;
            Scenario.quote(this.selectedScenario, this.quoteMessage)
                .then(() => {
                    this.requestingQuote = false;
                    this.closeDialogs();
                    this.quoteMessage = '';
                    this.success(this.$t('common.modals.successMessages.contactShortly'), 5000);
                })
                .catch(err => {
                    this.error(this.$t('common.errorTryAgain'), 5000);
                    console.warn('[ quote ] Something went wrong.', err);
                });
        } else {
            this.warn(this.$t('common.modals.warnMessages.selectScenario'));
            this.closeDialogs();
        }
    }

    warn(text, duration = 5000) {
        this.warning = text;

        setTimeout(() => {
            this.warning = undefined;
        }, duration);
    }

    error(text, duration = 5000) {
        this.errorMessage = text;

        setTimeout(() => {
            this.errorMessage = undefined;
        }, duration);
    }

    success(text, duration = 5000) {
        this.successMessage = text;

        setTimeout(() => {
            this.successMessage = undefined;
        }, duration);
    }

    help() {
        if (this.selectedScenario !== -1) {
            this.requestingHelp = true;
            Scenario.help(this.selectedScenario, this.helpMessage, this.helpContact)
                .then(() => {
                    this.requestingHelp = false;
                    this.closeDialogs();
                    this.helpMessage = null;
                    this.helpContact = null;
                    this.success(this.$t('common.modals.successMessages.weWillHelp'));
                })
                .catch(err => {
                    this.error(this.$t('common.errorTryAgain'), 5000);
                    console.warn('Quote error', err);
                });
        } else {
            this.warn(this.$t('common.modals.warnMessages.selectScenario'));
            this.closeDialogs();
        }
    }

    getShareDialog() {
        this.share = true;
        this.shareEmail = null;
        this.shareMessage = null;
    }

    shareScenario() {
        if (this.selectedScenario !== -1) {
            if (this.emailPattern.test(this.shareEmail)) {
                this.requestingShare = true;
                Scenario.share(this.selectedScenario, this.shareEmail, this.shareMessage)
                    .then(() => {
                        this.success(
                            this.$t('common.modals.successMessages.scenarioBeenShared', {
                                shareEmail: this.shareEmail,
                            }),
                            5000,
                        );
                        this.closeDialogs();
                    })
                    .catch(err => {
                        if (!this.emailPattern.test(this.shareEmail)) {
                            this.error(this.$t('common.errorEmailNotValid'), 5000);
                            console.warn('Quote error', err);
                        } else {
                            this.error(this.$t('common.errorTryAgain'), 5000);
                            console.warn('Quote error', err);
                        }

                        this.closeDialogs();
                    });
            } else {
                this.error(this.$t('common.errorEmailNotValid'));
            }
        } else {
            this.warn(this.$t('common.modals.warnMessages.selectScenario'));
            this.closeDialogs();
        }
    }

    selectMotor(motor) {
        if (this.$route.path !== this.getLink(motor.name))
            this.$router.push(this.getLink(motor.name));
    }

    getLink(name) {
        return '/motors/' + name.toLowerCase().replace(/\s/g, '-');
    }

    beforeMount() {
        this.$store.dispatch('activateScenario', undefined);
    }

    getSearchLink() {
        return '/scenarios?motor=' + this.motorSearch;
    }

    search() {
        let link = this.getSearchLink();
        if (this.$route.path !== link) this.$router.push(link);
    }
}
</script>
